/**
 * The shared **Range advisory** combinator: a warning, never an error, when one
 * numeric property leaves a plausible band. It owns presence, parse, NaN guard and
 * direction, so each rule is a table of thresholds that reports through one
 * warning **Rule arm** (GLOSSARY.md, "Range advisory").
 */
import { scalarSlotValue } from '../godot/variant/variantBool.js';
import { reportArm } from './ruleArms.js';
/**
 * Report a **Diagnostic** through `arm` for every threshold the node's
 * properties trip. Skips absent or non-numeric properties silently.
 */
export function rangeAdvisories(node, table, arm) {
    const diagnostics = [];
    for (const [property, thresholds] of Object.entries(table)) {
        const raw = node.rawProperties[property];
        if (raw === undefined)
            continue;
        // `scalarSlotValue`, not `parseFloat`: `inf` is a value above every bound,
        // not an unreadable property. `nan` reads as NaN and trips nothing, since
        // every comparison against it is false.
        const value = scalarSlotValue(raw);
        if (value === null)
            continue;
        for (const threshold of thresholds) {
            const tripped = 'over' in threshold
                ? value > threshold.over
                : value < threshold.under && (threshold.floor === undefined || value > threshold.floor);
            if (tripped)
                reportArm(diagnostics, arm, node, threshold.message(value));
        }
    }
    return diagnostics;
}
//# sourceMappingURL=rangeAdvisory.js.map